
export const data = {
    VUE_APP_GOOGLE_ID : 'AKfycbzvWg_fAzb_GdMxhAt965VflrMqMTXp_HvkWPfpE0OR5P7npGYwdNl1DouW9tpsntfpIg',
    // VUE_APP_MAIL_FRIAX : "jesus.r.chavez.q.94@gmail.com",
    // VUE_APP_TELEFONO_FRIAX : "7442077733",
    VUE_APP_MAIL_FRIAX : "friaxconstrucciones@hotmail.com",
    VUE_APP_TELEFONO_FRIAX : "6143669958",
    VUE_APP_MESSAGE_WHATSAPP_FRIAX : "Hola, me gustaría saber más sobre sus servicios",
    VUE_APP_FACEBOOK : 'https://www.instagram.com/friaxconstrucciones/',
    VUE_APP_INSTAGRAM : 'https://www.facebook.com/people/Friax-Construcciones/61565345063242/',
    VUE_APP_SERVICEID : 'service_4vzbrc8',
    VUE_APP_TEMPLATEID : 'template_bgmz80i',
    VUE_APP_USERID : "rFNy7i7jCKB9K85bW",
}